<script lang="ts">
    import {
        Card,
        CardTitle,
        CardText,
        Divider,
        ProgressCircular,
    } from "svelte-materialify/src";
    import { Doc } from "sveltefire";
</script>

<Card outlined>
    <CardTitle class="card-title">My Present-day</CardTitle>
    <Divider />
    <CardText class="remove-break">
        <Doc
            path={"about/present"}
            traceId={"aboutPresentRead"}
            let:data={present}
        >
            {#each present.info as info}
                <p>{info}</p>
            {/each}
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
    </CardText>
</Card>
